import styled from "@emotion/styled";

export const Divider = styled("hr")`
  border-top: 0.5px solid #d4d4d4;
  margin: 0;
  padding: 0;
`;
